import React, { Component } from 'react';
import './index.css';

class Row4 extends Component {
  description = [
    'اعتبار این پیش فاکتور تا دو هفته پس از تاریخ صدور می باشد.', 
    'افزونه های فعلی و آتی سامانه بورس ویو، در طول مدت قرارداد شامل افزایش هزینه نخواهد شد.', 
    <b>تعرفه خالص هرکاربر هر ماه 3623853 ریال است.</b>
  ]
  constructor(props) {
    super(props);
    this.state = {

    }
  }


  render() {
    const {pdfInfo} = this.props;
    let _plan = pdfInfo ? pdfInfo.plan : null;
    // let description = _plan && _plan.description ? _plan.description : [];
    const description = [
      'اعتبار این پیش فاکتور تا دو هفته پس از تاریخ صدور می باشد.'
    ];
    return (
      <div className='pdf-invoice-grid-row4'>
        <div className='pdf-invoice-grid-row4-side-header'>
          <div className='pdf-invoice-grid-row4-side-header-text'>{''}</div>
        </div>
        <div className='pdf-invoice-grid-row4-content'>
          <div className='pdf-invoice-grid-row4-content-wrapper'>
            <div className="display-flex-row-center">
              <div><b>توضیحات</b> :</div>
              <div>
                <ul>{description.map((item, index)=>{return (<li key={index}>{item}</li>)})}</ul>
              </div>
            </div>
            <div className='display-flex-column-center'>
              <div style={{whiteSpace: 'nowrap'}}><b>شماره حساب بانک سامان</b>: ۱-۲۳۰۹۱۳۹-۸۱۹-۸۲۰</div>
              <div style={{whiteSpace: 'nowrap'}}><b>شماره شبا</b> : IR۳۴۰۵۶۰۰۸۲۰۸۱۹۰۲۳۰۹۱۳۹۰۰۱</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}




export default Row4;
